module.exports = __webpack_public_path__ + "68cdd180a7333085df6277e998d01ce9.png";